import { SagaIterator } from 'redux-saga';
import { NATIVE_BLOB } from 'src/io/codecs/NativeBlob';
import { PdfEmbedding } from 'src/modules/common/types/PdfEmbedding';
import { PdfMergeWorkerRequest } from 'src/modules/worker/types/WorkerRequest';
import { createWorkerHandler } from 'src/modules/worker/utils/createWorkerHandler';
import { call } from 'typed-redux-saga';

export function* mergePdf(
  document: Blob,
  embeddings: ReadonlyArray<PdfEmbedding>,
): SagaIterator<Blob> {
  if (embeddings.length === 0) {
    return document;
  }

  const workerRequest: PdfMergeWorkerRequest = { document, embeddings };
  return yield* call(doOnWorker, workerRequest);
}

const doOnWorker = createWorkerHandler(
  '/pdf-merge-worker.js',
  NATIVE_BLOB,
)<PdfMergeWorkerRequest>;
